import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest } from "../../../api/controller/ActionController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const actionListState = atom({
    key: 'actionListState',
    default: [],
})

export const modalConfigDefault = { size: "md", wizard: false }

export const filtersDefault = []

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const actionDataStructureState = selector({
    key: 'actionDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Type',
                type: 'select',
                order: { table: 1, form: 1 }, 
				table: { editable: true },
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: [{ enabled: false }], view: ['same_as:update.0'], 
				rootValue: true,
				list: {
					ovf: false,
					data:[
						{ label: 'CLAIM', value: 'CLAIM' },
						{ label: 'DPR', value: 'DPR' },
					]
				},
            },
			{ 
                label: 'Name',
                type: 'text',
                order: { table: 2, form: 2 }, 
				table: { editable: true },
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: [{ enabled: false }], view: ['same_as:update.0'], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
